import React from 'react';
import { usePageTracking } from '../../lib/hooks/usePageTracking';
import { isOnboardingDisabled } from '../../lib/onboarding';

// Liste de vidéos YouTube à afficher (réelles)
const tutorialVideos = [
  {
    id: 'HC5cs0Hy-YA',
    title: 'Agent Libre : Signer un joueur',
    description: "Comment ajouter un agent libre à votre équipe et gérer les signatures."
  },
  {
    id: 'siGxAdBukxI',
    title: 'Commissaire : Gérer les demandes de ligue',
    description: "Accepter ou refuser une demande pour rejoindre une ligue en tant que commissaire."
  },
  {
    id: 'uwLa5h3ZEbg',
    title: 'Draft : Fonctionnement du repêchage',
    description: "Explication du déroulement du draft et des options disponibles."
  },
  {
    id: 'PGapiKx4Woc',
    title: 'Échange : Proposer un échange',
    description: "Comment proposer un échange à un autre joueur dans votre ligue."
  },
  {
    id: '_liuIx6gwPA',
    title: 'Échange : Réception et gestion',
    description: "Comment accepter ou refuser un échange reçu."
  },
  {
    id: 'nXv2ztQSz-4',
    title: 'Liste de protection',
    description: "Gérer la liste de protection de votre équipe avant le draft."
  },
  {
    id: 'UOgHd1OoiX0',
    title: 'Mon Équipe : Gestion des blessures',
    description: "Placer un joueur blessé sur la liste des blessés et gérer son retour."
  },
  {
    id: 'ivqx_Ji1H9k',
    title: 'Mon Équipe : Envoyer un joueur au Scratch',
    description: "Comment envoyer un joueur dans la section Scratch (hors alignement)."
  },
];

export function TutorialPage() {
  // Tracker cette page
  usePageTracking('tutorialpage');

  if (isOnboardingDisabled()) return null;

  const handleBack = () => {
    window.location.href = '/my-office';
  };
  return (
    <div className="card shadow-lg border-0">
      <div className="card-body p-5">
        <button
          className="btn btn-link mb-3"
          onClick={handleBack}
          title="Retour à Mon Bureau"
        >
          &larr; Retour
        </button>
        <h2 className="card-title mb-4">Tutoriels vidéo DynastyPool</h2>
        <p className="text-muted mb-5">Retrouvez ici les vidéos explicatives pour bien démarrer et maîtriser DynastyPool.</p>
        <div className="row g-4">
          {tutorialVideos.map((video) => (
            <div key={video.id} className="col-md-6">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title mb-2">{video.title}</h5>
                  <p className="card-text text-muted small mb-3">{video.description}</p>
                  <div className="ratio ratio-16x9">
                    <iframe
                      src={`https://www.youtube.com/embed/${video.id}`}
                      title={video.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ borderRadius: '8px', width: '100%', height: '100%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
